import styled from 'styled-components';
import {LIGHT_GRAY} from '../../../../globalVariables/GlobalVariables';
import {wrap} from '../../../textEditor/editorWrapper/EditorWrapper.css';
import {wrapEditor, wrapper} from '../../../../pages/branding/emailSubjectTextEditor/EmailSubjectTextEditor.css';

export const editorSection = styled.div`
    margin-block: 20px;
    ${wrapper}{
        width: 100%;
    }
`;

export const bodyEditor = styled.div`
    padding-block: 20px;
    ${wrap}{
        width: 100%;
    }
    .ql-toolbar.ql-snow{
        border-bottom: none;
        border-top: 1px solid ${LIGHT_GRAY};
    }
`;
export const subjectEditor = styled(wrapEditor)<{text: string}>`
    margin-bottom: 20px;
`;